import { render } from "./edit.html?vue&type=template&id=30d47b5b&ts=true"
import script from "./edit.ts?vue&type=script&lang=ts"
export * from "./edit.ts?vue&type=script&lang=ts"

import "./edit.scss?vue&type=style&index=0&lang=scss"
import "@vueform/toggle/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__